import { createAction } from '@reduxjs/toolkit';

enum ActionType {
  LOGIN = 'LOGIN',
  PERMISSION = 'PERMISSION',
}

export const actionLogin = createAction<any>(ActionType.LOGIN);
export const actionPermission = createAction<any>(ActionType.PERMISSION);

export default ActionType;

export * from './common';
